import BaseSessionService from 'ember-simple-auth/services/session';
import { service } from '@ember/service';
import type CurrentUserService from './current-user';
import * as Sentry from '@sentry/ember';
import type UserModel from 'back-office/models/user';

export default class SessionService extends BaseSessionService {
  @service declare currentUser: CurrentUserService;

  invalidate(): Promise<void> {
    Sentry.setUser(null);
    return super.invalidate();
  }

  async handleAuthentication() {
    try {
      const user = (await this.currentUser.load()) as UserModel;
      Sentry.setUser({
        email: user.email,
        id: user.id,
        username: `${user.firstName} ${user.lastName}`,
      });
    } catch (err) {
      /**
       * Does not invalidate with abord error, loading the current user is optional and may be canceled
       * `err instanceof AbortError` is false BTW, we check with the message
       */
      if ((err as Error).message === 'Aborted') {
        return;
      }
      await this.invalidate();
    }
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    session: SessionService;
  }
}
